import React from "react";
import { useTranslation } from "react-i18next";
import useLanguage from "../../../utils/useLanguage";

const InternalPrintableOrderView = React.forwardRef(
  ({ data, measuringUnit, orderDetails }, ref) => {
    const { currentDirection } = useLanguage();
    const { t } = useTranslation("general");

    const {
      orderNumber = "---",
      date = new Date().toLocaleDateString(),
      companyName = "---",
      notes = "---",
      createdBy = "--",
    } = orderDetails || {};

    // Transform the flat orderItems array into grouped structure
    const groupedData = data?.orderItems?.reduce((acc, item) => {
      const paperCode = item.paperCode;
      if (!acc[paperCode]) {
        acc[paperCode] = {
          code: paperCode,
          items: [],
        };
      }
      acc[paperCode].items.push(item);
      return acc;
    }, {});

    const paperGroups = groupedData ? Object.values(groupedData) : [];

    return (
      <div
        ref={ref}
        className="printable-order-view"
        dir={currentDirection}
        style={{ display: "none" }}
      >
        <section className="print-first-section">
          <div className="print-header">
            <h1>{t("fabricOrderList")}</h1>
          </div>

          {/* Order information section */}
          <div className="print-info-section">
            <div className="print-info-row">
              <div className="print-info-block">
                <div className="print-info-item">
                  <strong>{t("Date")}:</strong> {date}
                </div>
                <div className="print-info-item">
                  <strong>{t("orderNumber")}:</strong> {data.SON || orderNumber}
                </div>
              </div>
              <div className="print-info-block">
                <div className="print-info-item">
                  <strong>{t("organizationName")}:</strong> {companyName}
                </div>
                {createdBy && (
                  <div className="print-info-item">
                    <strong>{t("creator")}:</strong> {createdBy}
                  </div>
                )}
              </div>
            </div>
          </div>

          {/* Grouped paper items */}
          {paperGroups.map((group) => (
            <div key={group.code} className="print-paper-group">
              <h3 className="print-fabric-header">
                {t("categoryCode")}: {group.code}
              </h3>
              <table className="print-fabric-table">
                <thead>
                  <tr>
                    <th>{t("categoryName")}</th>
                    <th>{t("paperType")}</th>
                    <th>
                      {t("dimension")} ({t("cm")})
                    </th>
                    <th>
                      {t("paperThickness")} ({t("gram")})
                    </th>
                    <th>
                      {t("quantity")} ({t("ton")})
                    </th>
                    {/* <th>
                      {t("amountOfRolls")} ({t("roll")})
                    </th> */}
                  </tr>
                </thead>
                <tbody>
                  {group.items.map((item, index) => (
                    <tr key={index}>
                      <td>{item.paperName}</td>
                      <td>{item.paperType}</td>
                      <td>{item.dimension}</td>
                      <td>{item.paperThickness}</td>
                      <td>{item.amount}</td>
                      {/* <td>{item.amountOfRolls}</td> */}
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          ))}
        </section>

        <section className="print-notes-section">
          <h2>{t("notes")}: </h2>
          <p>{notes}</p>
        </section>

        <section className="print-footer u-margin--top_auto">
          <p className="t-headline-3">{t("ehsiblySecondSlogan")}</p>
          <p>{t("alhabbarSlogan")}</p>
        </section>
      </div>
    );
  }
);

export default InternalPrintableOrderView;
